import { gql } from "@apollo/client";
import { DELIVERY_UNIT_FIELDS } from "./common";
import { ADDRESS_FIELDS } from "./common";
import { PARTY_FIELDS } from "./party";

export const DROPSHIP_DELIVERY_FIELDS = gql`
${ADDRESS_FIELDS}
fragment DropshipDeliveryFields on DropshipDelivery {
    personFirstName:
    personLastName
    address {
        ...AddressFields }
  }`
 
export const WAREHOUSE_DELIVERY_FIELDS = gql`
${ADDRESS_FIELDS}
fragment WarehouseDeliveryFields on WarehouseDelivery {
    companyName
    address {
        ...AddressFields }
  }`

  export const MERCHANT_DELIVERY_FIELDS = gql`
${DROPSHIP_DELIVERY_FIELDS}
${WAREHOUSE_DELIVERY_FIELDS}
fragment MerchantDeliveryFields on MerchantDelivery {
    deliveryType
    dropshipDelivery { 
        ...DropshipDeliveryFields 
    }
    warehouseDelivery  { 
        ...WarehouseDeliveryFields 
    }
  }`

  export const PLATFORM_PRODUCER_CONTRACT_FIELDS = gql`
  ${DELIVERY_UNIT_FIELDS}
  ${PARTY_FIELDS}
  fragment PlatformProducerContractFields on PlatformProducerContract {
    id
    producerPartyId
    producerParty {
        ...PartyFields
    }
    producerDeliveryUnitId
    
    producerDeliveryUnit {
        ...DeliveryUnitFields
    }
    deliveryUnitSaleCatalogId
    startsAt
    endsAt
    createdAt
    updatedAt
    isActive
  }`
  
//   type ProducerDelivery {
//     fromAddress: Address!
//   }

export const PLATFORM_MERCHANT_CONTRACT_FIELDS = gql`
${DELIVERY_UNIT_FIELDS}
${PARTY_FIELDS}
${MERCHANT_DELIVERY_FIELDS}
fragment PlatformMerchantContractFields on PlatformMerchantContract {
    id
    producerPartyId
    producerParty {
        ...PartyFields
    }
    producerDeliveryUnitId
    producerDeliveryUnit {
        ...DeliveryUnitFields
    }
    merchantPartyId
    merchantParty {
        ...PartyFields
    }
    delivery { 
        ...MerchantDeliveryFields
    }
    platformSaleCatalogId
    startsAt
    endsAt
    createdAt
    updatedAt
    isActive
  }`